import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { createOrUpdateController, createOrUpdateTab, resetTabControllerState } from './option-group-tab-controller-index-keeper.action';
import { selectMarketGroupByEventAndMarket } from './option-group-tab-controller-index-keeper.state';
import { ControllerPayload, TabControllerResponseState, TabPayload } from './tab-controller.model';

@Injectable({ providedIn: 'root' })
export class TabControllerFacadeService {
    constructor(private _store: Store) {}

    createOrUpdateTab(payload: TabPayload) {
        this._store.dispatch(createOrUpdateTab(payload));
    }

    createOrUpdateController(payload: ControllerPayload) {
        this._store.dispatch(createOrUpdateController(payload));
    }

    resetTabControllerState() {
        this._store.dispatch(resetTabControllerState());
    }

    getTabControllerState(marketId: string, eventId: string): Observable<TabControllerResponseState | null> {
        return this._store.select(selectMarketGroupByEventAndMarket(eventId, marketId));
    }
}
